import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import SecureInquiryPortal from "./sections/SecureInquiryPortal";
import OfficeRemoteDetails from "./sections/OfficeRemoteDetails";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <SecureInquiryPortal />
      <OfficeRemoteDetails />
      <Footer />
    </div>;
}